/**
 * Motifs d'exclusion d'un camion de l'optimisation globale (`ignoredVehicles[].reason` de
 * POST /tours-planning/optimize-all). L'API joint un `details` rédigé pour chaque motif ;
 * ces libellés ne servent que s'il manque.
 */
const IGNORED_VEHICLE_REASON_LABELS = {
  missing_coordinates: 'Coordonnées manquantes',
  missing_registration: 'Immatriculation manquante',
  not_eligible: 'Indisponible ce jour (véhicules du jour)',
  tour_not_editable: 'Tournée déjà démarrée',
  vehicle_full: 'Camion déjà plein',
};

/** Texte à afficher pour un camion ignoré : le détail de l'API, sinon le libellé du motif, sinon le code. */
export const ignoredVehicleLabel = (vehicle) =>
  vehicle.details ||
  IGNORED_VEHICLE_REASON_LABELS[vehicle.reason] ||
  vehicle.reason;
